import React, { useEffect } from 'react';

import { Box, useRadio, useRadioGroup, Wrap, WrapItem } from '@chakra-ui/react';

function RadioCard(props) {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as='label' m={0} border='0px solid red'>
      <input {...input} />
      <Box
        {...checkbox}
        cursor='pointer'
        borderWidth='2px'
        borderRadius={25}
        // boxShadow="md"
        // bg= 'blue'
        _checked={{
          bg: 'brand.500',
          color: 'gold',
          fontWeight: 600,
          borderColor: 'brand.500',
        }}
        _focus={{
          boxShadow: 'outline',
        }}
        px={5}
        py={0}
      >
        {props.children}
      </Box>
    </Box>
  );
}

// Step 2: Use the `useRadioGroup` hook to control a group of custom radios.
function VoucherSelector({ options, initialValue, onChange }) {
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'vouchers',
    defaultValue: options[0].id,
    // value: initialValue,
    onChange: onChange,
  });

  const group = getRootProps();

  useEffect(()=>{

  },[initialValue])
  
  return (
    <Wrap spacing='30px' p={5} bg='#2a3745' borderRadius={25} boxShadow='md' justifyContent='space-around' {...group} >
      {options.map((option) => {
        const radio = getRadioProps({ value: option.id });
        return (
          <WrapItem key={option.id}>
            <RadioCard {...radio}>
              {option.text}
            </RadioCard>
          </WrapItem>
        );
      })}
    </Wrap>
  );
}

export default VoucherSelector;
